import React, { FC } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import App from './App';

/**
 * Use createBrowserRouter in order to use the `appRouter` outside of React components
 */
export const appRouter = createBrowserRouter([{ path: '*', element: <App /> }], { basename: '/ESS' });

const AppRouter: FC = () => {
  return <RouterProvider router={appRouter} />;
};

export default AppRouter;
